import { Component } from "@angular/core";
import { FeatureFlagsService } from "src/app/services/feature-flag/feature-flag.service";

@Component({
  selector: 'app-owner-details-wrapper',
  template: `
    <app-owner-details-v2 *ngIf="useRebranded"></app-owner-details-v2>
    <app-owner-details *ngIf="!useRebranded"></app-owner-details>
  `
})
export class OwnerDetailsComponentWrapper {
  public useRebranded: boolean;
  
  constructor(private featureFlagService: FeatureFlagsService) {
    this.useRebranded = this.featureFlagService.isEnabled('useRebrandedLayout');
  }
}